import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7f59ee6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-bg" }
const _hoisted_2 = { class: "modal-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ButtonDefault, {
        msg: "X",
        onButtonClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
      }),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}